<template>
  <div class="card exam-card">
    <div class="card-title">
      <div class="card-title__wrapper">
        <span>智能测试</span>
        <img
          class="planet"
          src="https://vanthink.oss-cn-qingdao.aliyuncs.com/6bf02c120054c01d3698d7231600f011.png" alt="">
      </div>
    </div>
    <div class="card-content-wrapper">
      <div class="item">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/c99fdf604270125676bb8e85d5cd56b5.png" alt="">
        <button @click="start('levelDialog')" class="btn btn-plain btn-circle">去闯关</button>
      </div>
      <div class="item">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/e096a12cb001f9ec00f2b4f0b70cfd88.png" alt="">
        <button @click="start('fallibleSet')" class="btn btn-plain btn-circle">去练习</button>
      </div>
      <div class="item">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/42fbcfc2f02ad2033d9b0f6cb1161e6d.png" alt="">
        <button @click="start('stageTest')" class="btn btn-plain btn-circle">去测试</button>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';

export default {
  methods: {
    start(scene) {
      let type = '';
      switch (scene) {
        case 'levelDialog':
          type = 'pass';
          break;
        case 'fallibleSet':
          type = 'test';
          break;
        default:
          type = 'drill';
      }
      utils.get('/api/home/student/test/public/get/frontTesting', {
        type,
      }).then(() => {
        this.$emit('change', { scene });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/common/breadcrumb.scss";
.exam-card {
  width: max-content;
  background: #fff;
  border-radius: 24px;
  .card-title {
    background: #45a0eb;
  }
  .card-content-wrapper {
    padding: 20px 0 10px;
    display: flex;
    overflow: hidden;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 20px;
      img {
        height: 135px;
      }
      .btn {
        margin-top: 10px;
        padding: 5px 10px;
        font-weight: 700;
      }
    }
  }
}
</style>
